// 3rd party
import { Directive, Input, Output, DoCheck, HostListener, HostBinding, EventEmitter } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[my-dt-row]',
  // tslint:disable-next-line:use-host-property-decorator
  host: { '[class]': '"my-dt-row"' }
})
export class MyDTRowDirective implements DoCheck {

  @HostBinding('class.selected') classSelected: boolean;

  @Output() onChange: EventEmitter<any> = new EventEmitter();

  item: any;

  @Input('my-dt-row')
  set setItem(item: any) {
    this.item = item;
  }

  constructor() { }

  ngDoCheck() {
    if (this.classSelected !== this.item.checked) {
      this.classSelected = this.item.checked;
      this.onChange.emit(this.item);
    }
  }

  @HostListener('click') onClick() {
    this.item.checked = !this.item.checked;
    this.classSelected = this.item.checked;
    this.onChange.emit(this.item);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/my-dt/my-dt-row.directive.ts